<template>
  <div class="page page-404">
    <h1>{{ t('notFound.title') }}</h1>
    {{ t('notFound.prefix') }} <router-link to="/">{{ t('notFound.backToHome') }}</router-link> {{ t('notFound.middle') }}
    <a :href="`mailto:${email}`">{{ t('notFound.contact') }}</a>
  </div>
</template>

<script>
  import { useAppStore } from '@/stores/useAppStore'
  import { useStrings } from '@/composables/useStrings.ts'

  export default {
    name: 'not-found-page',
    setup() {
      const appStore = useAppStore()
      const { t } = useStrings()
      return {
        t,
        email: appStore.contactData.email,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .page-404 {
    margin-top: 10%;
    text-align: center;
    font-size: 1.2rem;

    a {
      text-decoration: underline;
    }
  }
</style>
